var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import { Grid, Typography, Button, Icon, useLinkResolver } from "../../components";
import { List, ListItem, TickCircleIconWrapper, ListItemText } from "../../prf/InsuranceScope/InsuranceScope.styled";

var HeadlineSection = function HeadlineSection(_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      btnText = _a.btnText,
      link = _a.link,
      backgroundColor = _a.backgroundColor,
      style = _a.style,
      color = _a.color,
      _b = _a.list,
      list = _b === void 0 ? [] : _b,
      backgroundColorItem = _a.backgroundColorItem,
      anchor = _a.anchor;
  var resolveAction = useLinkResolver().resolveAction;
  return React.createElement(Grid.Box, {
    id: anchor,
    style: __assign({
      padding: "2rem 0",
      backgroundColor: backgroundColor
    }, style)
  }, React.createElement(Grid.Box, {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    maxWidth: "746px",
    m: "0 auto"
  }, !!title && React.createElement(Typography, {
    color: color,
    variant: "h2",
    textAlign: "center",
    isUpperCase: true,
    mb: 4
  }, title), !!subtitle && React.createElement(Typography, {
    color: color,
    textAlign: "center"
  }, subtitle), !!list.length && React.createElement("div", {
    style: {
      margin: "0 auto",
      maxWidth: "420px"
    }
  }, React.createElement(List, null, list.map(function (item, idx) {
    return React.createElement(ListItem, {
      key: "provide_" + idx
    }, React.createElement(TickCircleIconWrapper, null, React.createElement(Icon, {
      name: "TickCircle",
      width: 24,
      height: 24
    })), React.createElement(ListItemText, {
      bg: backgroundColorItem
    }, item));
  }))), !!btnText && React.createElement(Grid.Box, {
    justifyContent: "center",
    display: "flex",
    mt: 2
  }, React.createElement(Button, {
    isPrimary: true,
    onClick: function onClick() {
      return resolveAction(link);
    }
  }, btnText))));
};

export default HeadlineSection;